<template>
  <div :class="$style.container">
    <div :class="$style.content">
      <div :class="$style.column">
        {{ item.date.substr(0, 10).split("-").reverse().join(".") }} /
        {{ item.date.substr(11, 5) }}
      </div>
      <div :class="$style.column">
        <!-- <img :src="getStatus()" alt="" /> -->
        {{ getStatus() }}
      </div>
      <div :class="$style.column">
        {{ item.counterparty?.name }}
      </div>
      <div :class="$style.column">
        {{ getEvent() }}
      </div>
      <div :class="$style.column">{{ item.purpose }}</div>
      <div :class="$style.column">{{ item.event }}</div>
      <div :class="$style.column">
        {{ item.counterparty?.city }}
      </div>
      <div :class="$style.column">
        {{ item.counterparty?.region }}
      </div>
      <div :class="$style.column">
        {{ item.responsible_manager.name || item.responsible_manager.username }}
      </div>
    </div>
    <div :class="$style.edit">
      <img
        v-if="!isSettingsOpen"
        @click.stop="isSettingsOpen = !isSettingsOpen"
        src="/icons/ellipsis.svg"
        alt=""
      />
      <img
        v-else
        @click.stop="isSettingsOpen = !isSettingsOpen"
        src="/icons/medium-cross.svg"
        alt=""
      />
      <div v-if="isSettingsOpen" :class="$style.settings">
        <div @click.stop="edit">
          <img src="/icons/edit-black.svg" alt="" />Редактировать
        </div>
        <div @click.stop="remove" :class="$style.red">
          <img src="/icons/delete.svg" alt="" />Удалить
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FILTERS from "@/assets/constants/filters.json";
export default {
  data() {
    return {
      isSettingsOpen: false,
      events: FILTERS.events,
      statuses: FILTERS.event_statuses,
    };
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    async remove() {
      await this.$store.dispatch("deleteEvent", this.item.id);
      await this.$store.dispatch("getEvents", {});
      this.isSettingsOpen = false;
    },
    edit() {
      this.$router.push(`/event/${this.item.id}`);
    },
    getEvent() {
      return this.events.find((i) => i.slug == this.item.event_type).title;
    },
    getStatus() {
      return this.statuses.find((i) => i.slug == this.item.status).title;
    },
  },
};
</script>

<style lang="scss" module>
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  background-color: $bg-secondary;
  padding: 1.5rem;
  border-bottom: 1px solid $bg-separator;
  @include Body1;
  .date {
    flex: 0 0 5rem;
  }
  .content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1 1 auto;
    .column {
      min-width: 9.5rem;
      width: 100%;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      &:last-child {
        min-width: none;
        width: 9.5rem;
      }
      &.empty {
        color: $red;
      }
      .dot {
        width: 0.5rem;
        height: 0.5rem;
        flex: 0 0 0.5rem;
        border-radius: 50%;
        &.orange {
          background-color: $orange;
        }
        &.grey {
          background-color: $t-secondary;
        }
        &.green {
          background-color: $main-green;
        }
        &.purple {
          background-color: $purple;
        }
        &.blue {
          background-color: $blue-primary;
        }
        &.red {
          background-color: $red-primary;
        }
      }
    }
  }

  .edit {
    width: 1.5rem;
    cursor: pointer;
    position: relative;
    .settings {
      width: 15rem;
      position: absolute;
      top: 0;
      right: 2.5rem;
      background-color: $bg-secondary;
      border: 1px solid $bg-separator;
      border-radius: 0.25rem;
      div {
        display: flex;
        gap: 0.5rem;
        align-items: center;
        @include Subtitle;
        cursor: pointer;
        padding: 0.5rem 1rem;
        border-bottom: 1px solid $bg-separator;
        &.red {
          color: $red;
          border-bottom: none;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.v-enter-active,
.v-leave-active {
  transition: all 0.3s ease;
  max-height: 3000px;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  max-height: 0;
}
</style>
